import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { ModalSpinner } from 'dibs-elements/exports/ModalSpinner.tsx';
import { lazy, Suspense, type ComponentProps, type FC } from 'react';

const LazyModalContent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedSellerDetailsModal" */ './PdpSharedSellerDetailsModal.tsx'
        )
);

export const PdpSharedSellerDetailsModalLazy: FC<
    ComponentProps<typeof LazyModalContent>
> = props => {
    const { isOpen, onClose, ...rest } = props;

    return isOpen ? (
        <ModalContainer modalSize="medium" modalPosition="top" isOpen={isOpen} onClose={onClose}>
            <ModalCloseButton onClick={onClose} />
            <Suspense fallback={<ModalSpinner isOpen />}>
                <LazyModalContent isOpen={isOpen} onClose={onClose} {...rest} />
            </Suspense>
        </ModalContainer>
    ) : null;
};
